import { TranslatedText } from '../Translation';

export interface FilterKey {
  id: number;
  slug: string;
  title: string;
  titleTranslation: TranslatedText;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const filterKeyFromResponse = (responseData: any): FilterKey => ({
  id: responseData.id,
  slug: responseData.slug,
  title: responseData.title,
  titleTranslation: responseData.title_translation ?? {},
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
